import { Agreement } from "./Agreement";
import {
  ACTION_AGREEMENT_DELETE_FAILED,
  ACTION_AGREEMENT_DELETE_SUCCESS,
  ACTION_AGREEMENTS_SAVED,
  ACTION_CREATE_AGREEMENT,
  ACTION_CREATE_AGREEMENT_DIALOG_HIDE,
  ACTION_CREATE_AGREEMENT_DIALOG_SHOW,
  ACTION_CREATE_AGREEMENT_FAILED,
  ACTION_CREATE_AGREEMENT_SUCCESS,
  ACTION_DELETE_AGREEMENT,
  ACTION_DOWNLOAD_AGREEMENTS,
  ACTION_DOWNLOAD_AGREEMENTS_STARTED,
  ACTION_LOAD_AGREEMENTS,
  ACTION_LOAD_AGREEMENTS_COMPLETE,
  ACTION_SAVE_AGREEMENTS,
  ACTION_UPLOAD_AGREEMENTS,
  ACTION_UPLOAD_AGREEMENTS_COMPLETE,
  ACTION_UPLOAD_AGREEMENTS_FAILED,
  ACTION_UPLOAD_AGREEMENTS_SUCCEEDED,
} from "./constants";

export interface LoadAgreementsAction {
  type: typeof ACTION_LOAD_AGREEMENTS;
}

export function loadAgreements(): LoadAgreementsAction {
  return {
    type: ACTION_LOAD_AGREEMENTS,
  };
}

export interface LoadAgreementsCompleteAction {
  type: typeof ACTION_LOAD_AGREEMENTS_COMPLETE;
  agreements: Array<Agreement>;
}

export function loadAgreementsComplete(
  agreements: Array<Agreement>
): LoadAgreementsCompleteAction {
  return {
    type: ACTION_LOAD_AGREEMENTS_COMPLETE,
    agreements: agreements,
  };
}

export interface ShowCreateAgreementDialogAction {
  type: typeof ACTION_CREATE_AGREEMENT_DIALOG_SHOW;
}

export function showCreateAgreementDialog(): ShowCreateAgreementDialogAction {
  return {
    type: ACTION_CREATE_AGREEMENT_DIALOG_SHOW,
  };
}

export interface HideCreateAgreementDialogAction {
  type: typeof ACTION_CREATE_AGREEMENT_DIALOG_HIDE;
}

export function hideCreateAgreementDialog(): HideCreateAgreementDialogAction {
  return {
    type: ACTION_CREATE_AGREEMENT_DIALOG_HIDE,
  };
}

export interface CreateAgreementAction {
  type: typeof ACTION_CREATE_AGREEMENT;
  agreement: Agreement;
}

export function createAgreement(agreement: Agreement): CreateAgreementAction {
  return {
    type: ACTION_CREATE_AGREEMENT,
    agreement: agreement,
  };
}

export interface CreateAgreementSuccessAction {
  type: typeof ACTION_CREATE_AGREEMENT_SUCCESS;
  payload: Agreement;
}

export function createAgreementSuccess(
  agreement: Agreement
): CreateAgreementSuccessAction {
  return {
    type: ACTION_CREATE_AGREEMENT_SUCCESS,
    payload: agreement,
  };
}

export interface AgreementDeleteSuccessAction {
  type: typeof ACTION_AGREEMENT_DELETE_SUCCESS;
}

export function agreementDeleteSuccess(): AgreementDeleteSuccessAction {
  return {
    type: ACTION_AGREEMENT_DELETE_SUCCESS,
  };
}

export interface AgreementDeleteFailedAction {
  type: typeof ACTION_AGREEMENT_DELETE_FAILED;
}

export function agreementDeleteFailed(): AgreementDeleteFailedAction {
  return {
    type: ACTION_AGREEMENT_DELETE_FAILED,
  };
}

export interface CreateAgreementFailedAction {
  type: typeof ACTION_CREATE_AGREEMENT_FAILED;
}

export function createAgreementFailed(): CreateAgreementFailedAction {
  return {
    type: ACTION_CREATE_AGREEMENT_FAILED,
  };
}

export interface DeleteAgreementAction {
  type: typeof ACTION_DELETE_AGREEMENT;
  payload: Agreement;
}

export function deleteAgreement(agreement: Agreement): DeleteAgreementAction {
  return {
    type: ACTION_DELETE_AGREEMENT,
    payload: agreement,
  };
}

export interface UploadAgreementsAction {
  type: typeof ACTION_UPLOAD_AGREEMENTS;
  content: File;
}

export function uploadAgreements(content: File): UploadAgreementsAction {
  return {
    type: ACTION_UPLOAD_AGREEMENTS,
    content: content,
  };
}

export interface AgreementUploadSucceededAction {
  type: typeof ACTION_UPLOAD_AGREEMENTS_SUCCEEDED;
  agreements: Array<Agreement>;
  agreementImportId: string;
}

export function agreementsUploadSucceeded(
  agreements: Array<Agreement>,
  agreementImportId: string
): AgreementUploadSucceededAction {
  return {
    type: ACTION_UPLOAD_AGREEMENTS_SUCCEEDED,
    agreements: agreements,
    agreementImportId: agreementImportId,
  };
}

export interface AgreementUploadFailedAction {
  type: typeof ACTION_UPLOAD_AGREEMENTS_FAILED;
  errors: Array<string>;
}

export function agreementsUploadFailed(
  errors: Array<string>
): AgreementUploadFailedAction {
  return {
    type: ACTION_UPLOAD_AGREEMENTS_FAILED,
    errors: errors,
  };
}

export interface CompleteAgreementsUploadAction {
  type: typeof ACTION_UPLOAD_AGREEMENTS_COMPLETE;
}

export function completeAgreementsUpload(): CompleteAgreementsUploadAction {
  return {
    type: ACTION_UPLOAD_AGREEMENTS_COMPLETE,
  };
}

export interface SaveAgreementsAction {
  type: typeof ACTION_SAVE_AGREEMENTS;
  agreementImportId: string;
}

export function saveAgreements(
  agreementImportId: string
): SaveAgreementsAction {
  return {
    type: ACTION_SAVE_AGREEMENTS,
    agreementImportId: agreementImportId,
  };
}

export interface AgreementsSavedAction {
  type: typeof ACTION_AGREEMENTS_SAVED;
}

export function agreementsSaved(): AgreementsSavedAction {
  return {
    type: ACTION_AGREEMENTS_SAVED,
  };
}

export interface DownloadAgreementsAction {
  type: typeof ACTION_DOWNLOAD_AGREEMENTS;
}

export function downloadAgreements(): DownloadAgreementsAction {
  return {
    type: ACTION_DOWNLOAD_AGREEMENTS,
  };
}

export interface DownloadAgreementsStartedAction {
  type: typeof ACTION_DOWNLOAD_AGREEMENTS_STARTED;
}

export function downloadAgreementsStarted(): DownloadAgreementsStartedAction {
  return {
    type: ACTION_DOWNLOAD_AGREEMENTS_STARTED,
  };
}
